import { render } from "./urgence.vue?vue&type=template&id=e0efc872"
import script from "./urgence.vue?vue&type=script&lang=js"
export * from "./urgence.vue?vue&type=script&lang=js"

import "./urgence.vue?vue&type=style&index=0&id=e0efc872&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__